export const COURSE_CATEGORIES_ROUTE_TYPE = 'kurser';
export const MACHINE_CATEGORIES_ROUTE_TYPE = 'maskine';
export const SERVICE_CATEGORIES_ROUTE_TYPE = 'ydseler';
export const PRODUCTS_CATEGORIES_ROUTE_TYPE = 'produkter';
export const BUSINESS_CATEGORIES_ROUTE_TYPE = 'virksomhed';
export const SPECIAL_BUSINESS_CATEGORIES_ROUTE_TYPE = 'speciel-virksomhed';

export const CATEGORY_ITEMS = [
    {
        title: 'Arrangementer, messer, kurser',
        subTitle: 'Kategorier til arrangementer, messer, kurser',
        href: '#/kategorier/' + COURSE_CATEGORIES_ROUTE_TYPE
    },
    {
        title: 'Kob & Salg',
        subTitle: 'Kategorier til kob & salg',
        href: '#/kategorier/' + MACHINE_CATEGORIES_ROUTE_TYPE
    },
    {
        title: 'Ydelser',
        subTitle: 'Kategorier til ydelser',
        href: '#/kategorier/' + SERVICE_CATEGORIES_ROUTE_TYPE
    },
    {
        title: 'Produkter mv.',
        subTitle: 'Kategorier til produkter mv.',
        href: '#/kategorier/' + PRODUCTS_CATEGORIES_ROUTE_TYPE
    },
    {
        title: 'Virksomhedskategorier',
        subTitle: 'Kategorier af virksomheder',
        href: '#/kategorier/' + BUSINESS_CATEGORIES_ROUTE_TYPE
    },
    {
        title: 'Speciel branche kategori',
        subTitle: 'Kategorier af særlig virksomheder',
        href: '#/kategorier/' + SPECIAL_BUSINESS_CATEGORIES_ROUTE_TYPE
    }
];





// WEBPACK FOOTER //
// ./web/src/components/editors/TreeEditorRouteTypes.js